import { Breadcrumb, Button, Col, Drawer, Flex, Form, Input, Layout, Popconfirm, Row, Select, Table, Tag, theme } from 'antd';
import { FilterOutlined, HomeOutlined, DeleteOutlined, EyeOutlined, EditOutlined } from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react'
import data from './sampleData';

const { Search } = Input;
const { Header, Footer, Sider, Content } = Layout;

export default function Sample({ props }) {
    const componentMounted = useRef(false);
    const [searchValues, setSearchValues] = useState({
        roleId: { filterBy: '', value: '' },
        roleName: { filterBy: '', value: '' },
        description: { filterBy: '', value: '' },
        status: { filterBy: '', value: '' },
    });
    const [filterValues, setFilterValues] = useState({});
    const [open2, setOpen2] = useState(false);

    // drawer handling for search filter
    const showDrawer2 = () => {
        setOpen2(true);
    };
    const onClose2 = () => {
        setOpen2(false);
    };
    useEffect(() => {
        console.log("___filter values :", filterValues)
    }, [filterValues])

    const handleSearchFilter = () => {
        const tempObject = {};
        console.log("___searchValues", searchValues)
        for (const key in searchValues) {
            if (searchValues.hasOwnProperty(key)) {
                key !== 'status' ? tempObject[key] = searchValues[key].value : tempObject[key] = searchValues[key].filterBy
            }
        }
        setFilterValues(tempObject)

    }

    const columns = [
        {
            title: 'Role ID',
            dataIndex: 'roleId',
            key: 'roleId',
            // ...getColumnSearchProps('roleID'), // You may need to define getColumnSearchProps function
        },
        {
            title: 'Role Name',
            dataIndex: 'roleName',
            key: 'roleName',
            // ...getColumnSearchProps('roleName'), // You may need to define getColumnSearchProps function
            sorter: (a, b) => a.address.length - b.address.length,
            sortDirections: ['descend', 'ascend'],
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            // ...getColumnSearchProps('description'), // You may need to define getColumnSearchProps function
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            fixed:'right',
            sorter: (a, b) => a.status.length - b.status.length,
            sortDirections: ['descend', 'ascend'],
            // ...getColumnSearchProps('status'), // You may need to define getColumnSearchProps function,
            render: (_, record) => (
                record.status === 'active' ? (<Tag color='purple' style={{ width: 90, textAlign: 'center' }}>Active</Tag>) : (<Tag color='warning' style={{ width: 90, textAlign: 'center' }}>Deactive</Tag>)
            ),
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            fixed:'right',
            render: (_, record) => (
                <Flex gap="small" justify="center" align="center" vertical>
                    <Flex gap="middle" wrap="wrap">
                        <Button type="primary" icon={<EditOutlined />} size='small' />
                        <Button icon={<EyeOutlined />} size='small' />
                        <Button danger type="primary" icon={<DeleteOutlined />} size='small' />
                    </Flex>
                </Flex>
            ),
            //   ...getColumnSearchProps('action'), // You may need to define getColumnSearchProps function
        },
    ];

    const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();

    return (
        <>
            <Flex gap={20} justify='space-between' align='center' style={{
                margin: '16px',
                padding: '16px 24px',
                // minHeight: 280,
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Breadcrumb
                    items={[
                        {
                            href: '',
                            title: <HomeOutlined />,
                        },
                        {
                            title: 'Master Data / Role',
                        },
                    ]}
                />
                <Flex justify='center' align='center' gap={48}>
                    <Flex justify='center' align='center' gap={12}>
                        <Button onClick={showDrawer2} icon={<FilterOutlined style={{ paddingLeft: 8, paddingRight: 8 }} />} />
                        <Search placeholder="input search text" enterButton />
                    </Flex>
                    <Button type="primary"  >Add New</Button>
                </Flex>

            </Flex>
            <div style={{
                margin: '16px',
            }}>
                {
                    Object.keys(filterValues).length !== 0 &&
                    <Flex align='center' gap={12}>
                        {Object.keys(filterValues).map(key => (
                            filterValues[key].length !== 0 &&
                            <Tag bordered={false} closable color="success" key={key}>
                                {filterValues[key]}
                            </Tag>
                        ))}
                    </Flex>}
            </div>
            <div style={{
                margin: '16px',
                padding: 24,
                minHeight: "78svh",
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Table
                    columns={columns}
                    dataSource={data}
                    scroll={{ x: 'max-content' }}
                />
                {/* search filter drawer */}
                <Drawer title="Search Filter"
                    onClose={onClose2}
                    open={open2}
                    size='large'
                    // placement='bottom'
                    footer={[
                        <Flex justify='flex-end' align='center' gap='large'>
                            <Button>
                                Cancel
                            </Button>

                            <Popconfirm
                                title="Do you want to filter data?"
                                onConfirm={handleSearchFilter}
                                // onCancel={() => openNotificationWithIcon('error', 'Abort', `Canceled`, 'bottomLeft')}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button type="primary">
                                    Search
                                </Button>
                            </Popconfirm>
                        </Flex>
                    ]
                    }
                >
                    <Form layout="vertical">
                        {
                            Object.keys(data[0]).map((single, index) => (
                                <Row gutter={12} key={index}>
                                    <Col span={6}>
                                        <Form.Item label={single}>
                                            <Select
                                                placeholder="Filter by"
                                                onChange={(value) => {
                                                    setSearchValues(prev => ({
                                                        ...prev,
                                                        [single]: {
                                                            ...prev[single],
                                                            "filterBy": value
                                                        }
                                                    }))
                                                }}
                                                options={[
                                                    {
                                                        value: single !== 'status' ? "starts with" : "active",
                                                        label: single !== 'status' ? 'Starts with' : "Active"
                                                    },
                                                    {
                                                        value: single !== 'status' ? "ends with" : 'deactive',
                                                        label: single !== 'status' ? 'Ends with' : 'Deactive'
                                                    },
                                                    {
                                                        value: "equal to",
                                                        label: 'Equal to'
                                                    }
                                                ].filter(option => single !== 'status' || option.value !== 'equal to')}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={18}>
                                        <Form.Item label=" ">
                                            {single !== 'status' ? (<Input
                                                placeholder='Type search value here'
                                                value={searchValues["name"]}
                                                onChange={(e) => {
                                                    setSearchValues(prev => ({
                                                        ...prev,
                                                        [single]: {
                                                            ...prev[single],
                                                            "value": e.target.value
                                                        }
                                                    }))
                                                }}
                                                autoComplete='new-name'
                                            />) : (<></>)}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            ))
                        }
                    </Form>
                </Drawer>
            </div>
        </>
    )
}